import { createFileRoute } from '@tanstack/react-router';

import { CrmAddonGate } from '@/pages/crm/addon/AddonGate';
import { OfferBuilderPage } from '@/pages/crm/offers/builder/OfferBuilderPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function OfferBuilderRoute() {
	return (
		<CrmAddonGate>
			<OfferBuilderPage />
		</CrmAddonGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/crm/deals/$dealId_/offers/$versionId_/edit')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: OfferBuilderRoute,
});
